export default __webpack_public_path__ + "static/media/logo-white.7f036cf9.svg";